import React from "react";
import { Result } from "antd";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../routes";

function NotFound() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(ROUTES.PATHS.ADMIN.HOME, { replace: true });
  };

  return (
    <div className="default-text grid place-content-center h-screen">
      <Result
        status="404"
        extra={
          <div>
            <div className="text-4xl tracking-wide pb-2">404</div>
            <div className="text-subheading16 text-river-bed">
              Oops! The page you requested was not found.
            </div>
            <div className=" text-subheading16 text-river-bed flex gap-1.5 justify-center">
              <div>Try going back to</div>
              <div
                className="underline cursor-pointer text-primary"
                onClick={handleClick}
                aria-hidden="true"
              >
                Home
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default NotFound;
